module.exports = __webpack_public_path__ + "static/media/ibd_hips2.4271f2c1.png";